import { c as _c } from "react/compiler-runtime";
import { useProjectApiClient } from "@api/project-api/use-project-api-client";
import { useErrorContext } from "@context-providers/error-boundary/error-handling-context";
import { useMarkupContext } from "@context-providers/markup/markup-context";
import { IElementType, isIElementAttachment } from "@faro-lotv/ielement-types";
/**
 * Hook to provide a reusable function to refresh attachments if their signed URI has expired.
 */
export function useRefreshAttachment() {
  const $ = _c(8);
  const {
    projectId,
    updateAttachments,
    attachments
  } = useMarkupContext();
  const {
    handleErrorWithToast
  } = useErrorContext();
  let t0;
  if ($[0] !== projectId) {
    t0 = {
      projectId
    };
    $[0] = projectId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const projectApiClient = useProjectApiClient(t0);
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = function isAttachmentExpired(attachment) {
      if (!attachment.signedUriExpiresOn) {
        return false;
      }
      const expirationDate = new Date(attachment.signedUriExpiresOn);
      return new Date() > expirationDate;
    };
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const isAttachmentExpired = t1;
  let t2;
  if ($[3] !== attachments || $[4] !== handleErrorWithToast || $[5] !== projectApiClient || $[6] !== updateAttachments) {
    const refreshAttachmentIfExpired = async function refreshAttachmentIfExpired(ids) {
      const attachmentsToRefresh = [];
      ;
      try {
        const {
          page: attachmentsFetched
        } = await projectApiClient.getIElements({
          ids,
          types: [IElementType.attachment]
        });
        const fetchedMap = new Map(attachmentsFetched.filter(isIElementAttachment).map(attachment_0 => {
          attachmentsToRefresh.push(attachment_0);
          return [attachment_0.id, attachment_0];
        }));
        const updatedAttachments = attachments.map(attachment_1 => fetchedMap.get(attachment_1.id) ?? attachment_1);
        updateAttachments(updatedAttachments);
      } catch (t3) {
        const error = t3;
        handleErrorWithToast({
          id: `refreshAttachment-${Date.now().toString()}`,
          title: "Could not refresh the attachment",
          error
        });
        throw Error("Error while refreshing attachment", {
          cause: error
        });
      }
      return attachmentsToRefresh;
    };
    t2 = {
      refreshAttachmentIfExpired,
      isAttachmentExpired
    };
    $[3] = attachments;
    $[4] = handleErrorWithToast;
    $[5] = projectApiClient;
    $[6] = updateAttachments;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}